import { RouteRecordRaw } from 'vue-router';
import ProductGuideAppIndex from '@/entry-points/productguide/ProductGuideAppIndex.vue';

export const productguideRoutes: RouteRecordRaw[] = [
    {
        name: 'ProductGuide',
        path: '/external-guides/productguide',
        component: ProductGuideAppIndex,
        props: (route) => ({
            guideId: route.query.guideId as string
        }),
        meta: {
            isPublic: true
        }
    },
    {
        name: 'Redirect',
        path: '/:pathMatch(.*)*',
        redirect: {
            name: 'ProductGuide'
        }
    }];
